import React from "react";
import "./QuotePinnedCard.css";

const QuotePinnedCard = ({ pinned, formatDate }) => {
  if (!pinned) return null;

  return (
    <div className="wa-pinned-wrapper">
      <div className="wa-pinned-content">
        <span className="pin-icon">📌</span>

        <div className="wa-pinned-text">
          <div className="wa-title">
            {pinned.eventType || pinned?.service_id?.serviceName}
            {(pinned.budget || pinned.totalAmount) ? ` • ${String(pinned.budget || pinned.totalAmount || "").trim().startsWith("₹") ? "" : "₹"}${pinned.budget || pinned.totalAmount}` : ""}
          </div>

          {(pinned.location || pinned.city) && (
          <div className="wa-subtitle">
            Location: {pinned.location || pinned.city}
          </div>
          )}

          {(pinned.startDate || pinned.endDate) && (
          <div className="wa-subtitle">
            {[pinned.startDate ? formatDate(pinned.startDate) : null, pinned.endDate ? formatDate(pinned.endDate) : null].filter(Boolean).join(" – ")}
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuotePinnedCard;